/* ============================================
   SELLERSIGNUP.JSX
   📁 File location: src/screens/seller/auth/Sellersignup.jsx
   ✅ Profile Image upload added
   ✅ Phone number field added
   ✅ Location field added
   ✅ Sab fields pe onChange, value, state properly set
   ✅ Baki sab code same to same
   ============================================ */

import React, { useContext, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaHome, FaEnvelope, FaLock, FaEye, FaEyeSlash, FaUser, FaCamera } from "react-icons/fa";
import { FaGoogle, FaFacebookF, FaTwitter } from "react-icons/fa";
import logo from "../../../assets/images/logo.png";
import "../../../assets/css/sellers/dashboard/sellerauth/auth.css";
import axios from "axios";
import AppContext from "context/AppContext";

function Sellersignup() {
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================

  const { baseUrl, Navigate, regExpChecker } = useContext(AppContext);

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [location, setLocation] = useState("");
  const [status, setStatus] = useState("Active")
  // ✅ New: Profile Image state
  const [profileImage, setProfileImage] = useState();       // File object
  const [profileImagePreview, setProfileImagePreview] = useState(null); // Preview URL
  const profileImageRef = useRef(null);          // Hidden input ref

  const [showPassword, setShowPassword] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // ==========================================
  // TOGGLE PASSWORD VISIBILITY
  // ==========================================
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // ==========================================
  // ✅ PROFILE IMAGE HANDLER
  // ==========================================
  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate type
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      setErrorMessage("Only JPG, PNG or WEBP images are allowed.");
      return;
    }

    // Validate size (2MB)
    if (file.size > 2 * 1024 * 1024) {
      setErrorMessage("Image size must be less than 2MB.");
      return;
    }

    setProfileImage(file);
    setProfileImagePreview(URL.createObjectURL(file));
    setErrorMessage("");
  };

  // ==========================================
  // HANDLE FORM SUBMISSION
  // ==========================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    signupseller();
  };

  const signupseller = () => {
    setIsLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const formData = new FormData();
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("phonenumber", phoneNumber);
    formData.append("location", location);
    formData.append("profileImage", profileImage);
    formData.append('status', status);

    axios.post(`${baseUrl}/seller/auth/signup`, formData)
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          sendOtp();
        } else {
          setErrorMessage("Signup failed. Please try again.");
          console.log(response.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Something went wrong. Please try again.");
        setIsLoading(false);
      });
  };
  // ==========================================
  // Send Otp
  // ==========================================
  const sendOtp = () => {
    axios.post(`${baseUrl}/seller/otp/sendOtp`, {
      email: email
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          Navigate("/seller/otpverification", {
            state: {
              email: email,
              from: "signup",
            },
          });
        } else {
          setErrorMessage("OTP could not be sent.");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Something went wrong.");
        setIsLoading(false);
      });
  }

  // ==========================================
  // HANDLE SOCIAL SIGNUP
  // ==========================================
  const handleSocialSignup = (provider) => {
    alert(`${provider} signup coming soon!`);
  };

  // ==========================================
  // RENDER COMPONENT
  // ==========================================
  return (
    <div className="auth-page-container">
      <div className="auth-card">

        {/* ==========================================
            LEFT SIDE — PROMO SECTION
            ========================================== */}
        <div className="auth-promo-section">
          {/* Background Image */}
          <div className="auth-promo-bg"></div>

          {/* Floating Shapes */}
          <div className="auth-floating-shape auth-floating-shape-1"></div>
          <div className="auth-floating-shape auth-floating-shape-2"></div>
          <div className="auth-floating-shape auth-floating-shape-3"></div>

          {/* Content */}
          <div className="auth-promo-content">
            <img
              src={logo}
              alt="Estate Experts"
              className="navbar-logo"
            />
            <span className="auth-text">Estate Experts</span>
            <h2 className="auth-promo-title">Already Signed up?</h2>
            <p className="auth-promo-description">
              Log in to your account so you can continue building and editing your onboarding flows.
            </p>
            <Link to="/seller/login" className="auth-promo-btn">
              LOG IN
            </Link>
          </div>
        </div>

        {/* ==========================================
            RIGHT SIDE — SIGNUP FORM
            ========================================== */}
        <div className="auth-form-section">
          {/* Logo */}
          {/* <div className="auth-logo">
            <FaHome className="auth-logo-icon" />
            <span>Estate Experts</span>
          </div> */}

          {/* Form Container */}
          <div className="auth-form-container">
            <h1 className="auth-form-title">Sign Up for an Account</h1>
            {/* <p className="auth-form-description">
              Let's get you all set up so you can start creating your first onboarding experience.
            </p> */}

            {/* Error Message */}
            {errorMessage && (
              <div className="auth-error-message">
                {errorMessage}
              </div>
            )}

            {/* Success Message */}
            {successMessage && (
              <div className="auth-success-message">
                {successMessage}
              </div>
            )}

            {/* Signup Form */}
            <form onSubmit={handleSubmit}>
              {/* ✅ First Name & Last Name Row — same as before */}
              <div className="auth-form-row">
                <div className="auth-form-group">
                  <label className="auth-form-label">First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      setErrorMessage(regExpChecker("fullName", e.target.value));
                    }}
                    placeholder="Your first name"
                    className="auth-form-input"
                    required
                  />
                </div>
                <div className="auth-form-group">
                  <label className="auth-form-label">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={lastName}
                    onChange={(e) => {
                      setLastName(e.target.value);
                      setErrorMessage(regExpChecker("fullName", e.target.value));
                    }}
                    placeholder="Your last name"
                    className="auth-form-input"
                    required
                  />
                </div>
              </div>

              {/* ✅ Email — same as before */}
              <div className="auth-form-group">
                <label className="auth-form-label">Email</label>
                <div className="auth-input-wrapper">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrorMessage(regExpChecker("email", e.target.value));
                    }}
                    placeholder="Enter your email address"
                    className="auth-form-input"
                    required
                  />
                </div>
              </div>

              {/* ✅ Password — same as before */}
              <div className="auth-form-group">
                <label className="auth-form-label">Password</label>
                <div className="auth-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setErrorMessage(regExpChecker("password", e.target.value));
                    }}
                    placeholder="Enter a strong password"
                    className="auth-form-input"
                    required
                  />
                  <span
                    className="auth-password-toggle"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              {/* ✅ Phone Number & Location */}
              <div className="auth-form-row">
                <div className="auth-form-group">
                  <label className="auth-form-label">Phone Number</label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="+92 300 0000000"
                    className="auth-form-input"
                    required
                  />
                </div>
                <div className="auth-form-group">
                  <label className="auth-form-label">Location</label>
                  <input
                    type="text"
                    name="location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    placeholder="e.g., Lahore, Pakistan"
                    className="auth-form-input"
                    required
                  />
                </div>
              </div>

              {/* ✅ Terms & Conditions — same as before */}
              {/* <div className="auth-terms-wrapper">
                <input
                  type="checkbox"
                  id="acceptTerms"
                  checked={acceptTerms}
                  onChange={(e) => setAcceptTerms(e.target.checked)}
                  className="auth-checkbox"
                />
                <label htmlFor="acceptTerms" className="auth-terms-text">
                  I accept Estate Experts's{" "}
                  <Link to="/terms" className="auth-terms-link">
                    Terms & Conditions
                  </Link>
                </label>
              </div> */}

              {/* ✅ Submit Button — same as before */}
              <button
                type="button"
                onClick={signupseller}
                className={`auth-submit-btn ${isLoading ? "auth-btn-loading" : ""}`}
              >
                {isLoading ? "Creating Account..." : "SIGN UP"}

              </button>
            </form>

          </div>
        </div>

      </div>
    </div>
  );
}

export default Sellersignup;